// extracted by mini-css-extract-plugin
export default {"cardHeader":"Payment_cardHeader__rzrRg","cardTitle":"Payment_cardTitle__mbEPy","paymentCard":"Payment_paymentCard__J--Om","paymentMethods":"Payment_paymentMethods__UMSWf"};